import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds", "message"]
  static values = { deadline: String }

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  update() {
    const deadline = new Date(this.deadlineValue)
    const now = new Date()
    const diff = deadline - now

    if (diff <= 0) {
      this.showLaunched()
      return
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    this.daysTarget.textContent = days.toString().padStart(2, '0')
    this.hoursTarget.textContent = hours.toString().padStart(2, '0')
    this.minutesTarget.textContent = minutes.toString().padStart(2, '0')
    this.secondsTarget.textContent = seconds.toString().padStart(2, '0')

    // Update urgency message
    if (this.hasMessageTarget) {
      if (days === 0) {
        this.messageTarget.textContent = "Launching today!"
        this.messageTarget.classList.remove("text-orange-600")
        this.messageTarget.classList.add("text-red-600")
      } else if (days <= 3) {
        this.messageTarget.textContent = "Only " + days + " days left!"
        this.messageTarget.classList.remove("text-red-600")
        this.messageTarget.classList.add("text-orange-600")
      } else if (days <= 7) {
        this.messageTarget.textContent = "Launching next week"
        this.messageTarget.classList.remove("text-red-600", "text-orange-600")
      }
    }
  }

  showLaunched() {
    clearInterval(this.timer)
    this.element.innerHTML = `
      <div class="text-center py-8">
        <h3 class="text-3xl font-bold text-green-600">We're Live!</h3>
        <p class="mt-2 text-gray-600">Thank you for waiting. Start using the product now.</p>
      </div>
    `
  }
}
